import { Database } from "@vuex-orm/core";

import User from "@/models/User";
import user from "./modules/user";
import UserPreferences from "@/models/UserPreferences";
import userPreferences from "./modules/userPreferences";
import Account from "@/models/Account";
import account from "./modules/account";
import Customer from "@/models/Customer";
import customer from "./modules/customer";
import CustomerLookup from "@/models/CustomerLookup";
import customerLookup from "./modules/customerLookup";
import Message from "@/models/Message";
import message from "./modules/message";
import MessageScheduled from "@/models/MessageScheduled";
import messagesScheduled from "./modules/messagesScheduled";
import MessageLookup from "@/models/MessageLookup";
import messageLookup from "./modules/messageLookup";
import Note from "@/models/Note";
import note from "./modules/note";
import ContactInfo from "@/models/ContactInfo";
import contactInfo from "./modules/contactInfo";
import Address from "@/models/Address";
import address from "./modules/address";
import Appointment from "@/models/Appointment";
import appointment from "./modules/appointment";
import OtherInfo from "@/models/OtherInfo";
import otherInfo from "./modules/otherInfo";
import Settings from "@/models/Settings";
import settings from "./modules/settings";
import BizReviewSettings from "@/models/BizReviewSettings";
import bizReviewSettings from "./modules/bizReviewSettings";
import BizReviewType from "@/models/BizReviewType";
import bizReviewTypes from "./modules/bizReviewTypes";
import BizReviewHistory from "@/models/BizReviewHistory";
import bizReviewHistories from "./modules/bizReviewHistories";
import BizMetrics from "@/models/BizMetrics";
import bizMetrics from "./modules/bizMetrics";
import BizReviewFeedback from "@/models/BizReviewFeedback";
import bizReviewFeedbacks from "./modules/bizReviewFeedbacks";
import ListType from "@/models/ListType";
import listType from "./modules/listType";
import ListItem from "@/models/ListItem";
import listItem from "./modules/listItem";
import Chat from "@/models/Chat";
import chat from "./modules/chat";
import ChatMessage from "@/models/ChatMessage";
import chatMessage from "./modules/chatMessage";
import ChatLookup from "@/models/ChatLookup";
import chatLookup from "./modules/chatLookup";
import Telephony from "@/models/Telephony";
import telephony from "./modules/telephony";
import Call from "@/models/Call";
import call from "./modules/call";
import RedirectLink from "@/models/RedirectLink";
import redirectLink from "./modules/redirectLink";

const database = new Database();

database.register(User, user);
database.register(UserPreferences, userPreferences);
database.register(Account, account);
database.register(Customer, customer);
database.register(CustomerLookup, customerLookup);
database.register(ContactInfo, contactInfo);
database.register(Address, address);
database.register(Appointment, appointment);
database.register(OtherInfo, otherInfo);
database.register(Message, message);
database.register(MessageScheduled, messagesScheduled);
database.register(MessageLookup, messageLookup);
database.register(Note, note);
database.register(Settings, settings);
database.register(BizReviewType, bizReviewTypes);
database.register(BizReviewSettings, bizReviewSettings);
database.register(BizReviewHistory, bizReviewHistories);
database.register(BizMetrics, bizMetrics);
database.register(BizReviewFeedback, bizReviewFeedbacks);
database.register(ListType, listType);
database.register(ListItem, listItem);
database.register(Chat, chat);
database.register(ChatMessage, chatMessage);
database.register(ChatLookup, chatLookup);
database.register(Telephony, telephony);
database.register(Call, call);
database.register(RedirectLink, redirectLink);

export default database;
